export class GAPI{
    public static initObj = {
        clientId: '890197854915-uc96845ssubrf63tasc5usg41qpu5j0p.apps.googleusercontent.com',
        discoveryDocs: [
          'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
          'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
          'https://www.googleapis.com/discovery/v1/apis/plus/v1/rest',
        ],
        scope: 'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly'
    }
    public static apiKey = "AIzaSyCmWFDnBoWeIU68R0lvk3dWYL6cV9q3IBs"
}